import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { CHALLENGE_QUERY } from '../graphql/queries'
import { FETCH_CHALLENGE } from '../redux/action-types'
import { cleanupFetchChallenge } from '../redux/actions'

const useChallengeQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchChallenge)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.challenges.challenge,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(CHALLENGE_QUERY, { id }, dispatch, FETCH_CHALLENGE),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useChallengeQuery
